<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
  >
    <!-- <template #TEST="{field,row}">
        <Button>{{row[field.key]}}</Button>
      </template> -->
  </cTable>
</template>

<script>
import { add, getLost } from "@/api/order/lostList";
import { getAllClient } from "@/api/user/client";
import { getCountry } from "@/api/system/country";
import { getCity } from "@/api/system/city";
import { getAllService } from "@/api/user/internal";
import { getAgent } from "@/api/tracker/agent";

import cTable from "@/base/common/index";

export default {
  name: "airport",

  components: {
    cTable
  },
  data() {
    return {
      methods: {
        list: getLost,
        add,
        getCountry,
        getCity
      },
      config: {
        height: 630
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              const data = row.airway_number.split(/\s+/).map(item => {
                return {
                  airway_number: item,
                  lost_time: row.lost_time,
                  source: row.source,
                  city_name: row.city_name,
                  remarks: row.remarks
                };
              });
              this.$page
                .handleRequestMethods("add", data, true, true)
                .then(res => {
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            title: this.$t("add"),
            modalBind: {
              width: 600,
              draggable: true
            },
            formBind: {
              labelWidth: 120
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              airway_number: [
                {
                  required: true,
                  trigger: "blur"
                }
              ],
              lost_time: [
                {
                  required: true,
                  type: "date",
                  trigger: "change"
                }
              ],
              country: [
                {
                  required: true,
                  trigger: "change",
                  type: "number"
                }
              ],
              city_name: [
                {
                  required: true,
                  trigger: "change"
                }
              ]
            }
          },
          grid: [
            { airway_number: 24 },
            { lost_time: 24 },
            { source: 24 },
            { country: 24 },
            { city_name: 24 },
            { remarks: 24 }
          ],
          fields: [
            {
              name: () => this.$t("orderNum"),
              key: "airway_number",
              component: "Input",
              bind: {
                type: "textarea",
                rows: 5
              },
              placeholder() {
                return this.$t("enter") + this.$t("orderNum");
              }
            },
            {
              name: () => this.$t("lost_ticket_nums") + this.$t("time"),
              key: "lost_time",
              component: "DatePicker",
              placeholder: () => this.$t("lost_ticket_nums") + this.$t("time"),
              component: "DatePicker",
              disabledDate: true,
              bind: {
                type: "datetime"
              }
            },
            {
              name: () => this.$t("source"),
              key: "source",
              component: "Input",
              disabled: true,
              default: "OMS"
            },
            {
              name: () => this.$t("countryName"),
              key: "country",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("countryName");
              },
              config: { label: "code", value: "id" },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getCountry")
                  ).payload.rows;
                  this.$forceUpdate();
                },
                "on-change"({ fields, value }) {
                  fields.forEach(async ele => {
                    if (ele.key == "city_name") {
                      ele.disabled = true;
                      ele.options = [];
                      if (value) {
                        let res = await this.$page.handleRequestMethods(
                          "getCity",
                          { country_id: value }
                        );
                        ele.disabled = false;
                        ele.options = res.payload.rows;
                      }
                    }
                  });
                  this.$forceUpdate();
                }
              }
            },
            {
              name: () => this.$t("city_name"),
              key: "city_name",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("city_name");
              },
              config: {
                label: "title",
                value: "title"
              },
              disabled: ({ row }) => {
                return !row.country;
              }
            },
            {
              name: () => this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              bind: {
                type: "textarea",
                rows: 5
              },
              placeholder() {
                return this.$t("enter") + this.$t("Remarks");
              }
            }
          ]
        }
      },
      header: {
        config: {
          custom: false
        },
        searchs: [
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return this.$t("start") + this.$t("date") + this.$t("time");
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              "on-change"({ searchForm }) {
                searchForm.startTime = searchForm.startTime
                  ? this.$page.format.timeFormat(searchForm.startTime)
                  : "";
              }
            }
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return this.$t("end") + this.$t("date") + this.$t("time");
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              "on-change"({ searchForm }) {
                let time = this.$page.format.timeFormat(searchForm.endTime);
                if (time.slice(-8) === "00:00:00") {
                  time = time.split(" ")[0] + " " + "23:59:59";
                  searchForm.endTime = time;
                }
              }
            }
          },
          {
            key: "client_id",
            component: "Select",
            placeholder() {
              return this.$t("clientName");
            },
            clearable: true,
            options: [],
            config: { label: "account", value: "id" }
          },
          {
            key: "customer_service_id",
            component: "Select",
            placeholder() {
              return this.$t("serviceAccount");
            },
            clearable: true,
            options: []
          },
          {
            key: "deliver",
            component: "Select",
            placeholder() {
              return this.$t("localFaction");
            },
            clearable: true,
            options: [],
            config: { label: "agent_name", value: "agent_name" }
          },
          {
            key: "from_country",
            component: "Select",
            placeholder() {
              return this.$t("allow_depart");
            },
            clearable: true,
            options: [],
            config: { label: "code", value: "code" }
          },
          {
            key: "to_country",
            component: "Select",
            placeholder() {
              return this.$t("allow_arrive");
            },
            clearable: true,
            options: [],
            config: { label: "code", value: "code" }
          },
          {
            key: "source",
            component: "Select",
            placeholder() {
              return this.$t("source");
            },
            clearable: true,
            options: []
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",

            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 }
            }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning"
              },
              id: 1245
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            }
          ],
          methods: {
            export() {
              this.exportExc();
            },
            add() {
              this.getModal("add").open();
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60
        },
        {
          name: () => this.$t("orderNum"),
          key: "airway_number",
          align: "center"
        },
        {
          name: () => this.$t("lost_ticket_nums") + this.$t("time"),
          key: "lost_time",
          align: "center"
        },
        {
          name: () => this.$t("clientName"),
          key: "client_name",
          align: "center"
        },
        {
          name: () => this.$t("serviceAccount"),
          key: "service_name",
          align: "center"
        },
        {
          name: () => this.$t("allow_depart"),
          key: "from_country",
          align: "center"
        },
        {
          name: () => this.$t("allow_arrive"),
          key: "to_country",
          align: "center"
        },

        {
          name: () => this.$t("localFaction"),
          key: "deliver",
          align: "center"
        },

        {
          name: () => this.$t("source"),
          key: "source",
          align: "center"
        },
        {
          name: () => this.$t("Remarks"),
          key: "remarks",
          align: "center"
        },
        {
          name: () => this.$t("operate"),
          key: "operator_name",
          align: "center"
        }
      ]
    };
  },
  async mounted() {
    const client = (await getAllClient()).data.payload.rows;
    const from_country = (await getCountry({ allow_depart: 1 })).data.payload
      .rows;
    const to_country = (await getCountry({ allow_arrive: 1 })).data.payload
      .rows;
    const data = (await getAllService()).data.payload;
    let service = [];
    [1, 2, 3].forEach(item => {
      service = service.concat(data[item]);
    });
    let deliver = (
      await getAgent({ agent_type: "bag", status: "YES", types: "DELIVERY" })
    ).data.payload.rows;
    let source = await this.$sel.getData("LOST_SOURCE");
    this.header.searchs.forEach(item => {
      if (item.key === "client_id") item.options = client;
      if (item.key === "from_country") item.options = from_country;
      if (item.key === "to_country") item.options = to_country;
      if (item.key === "customer_service_id") item.options = service;
      if (item.key === "deliver") item.options = deliver;
      if (item.key === "source") item.options = source;
    });
  }
};
</script>
